export default __webpack_public_path__ + "static/media/caret-down.3726f50d.svg";